import _classCallCheck from "/app/node_modules/babel-runtime/helpers/classCallCheck";
import _createClass from "/app/node_modules/babel-runtime/helpers/createClass";
export var TeamApi = function () {
    function TeamApi(axios, store) {
        _classCallCheck(this, TeamApi);

        this.axios = axios;
    }

    _createClass(TeamApi, [{
        key: "findAllTeamForChannel",
        value: function findAllTeamForChannel(data) {
            return this.axios.$post("/team/team/find-All-Team-for-Channel", data);
        }
    }, {
        key: "getTeamManagement",
        value: function getTeamManagement(data) {
            return this.axios.$post("/team/team/find-team-management", data);
        }
    }, {
        key: "editTeam",
        value: function editTeam(data) {
            return this.axios.$post("/team/team/edit-team", data);
        }
    }, {
        key: "createdNewTeam",
        value: function createdNewTeam(data) {
            return this.axios.$post("/team/team/new-team", data);
        }
    }, {
        key: "findTeamForEdit",
        value: function findTeamForEdit(data) {
            return this.axios.$post("/team/team/find-team-for-edit", data);
        }
    }, {
        key: "editTeamManagement",
        value: function editTeamManagement(data) {
            return this.axios.$post("/team/team/edit-team-management", data);
        }
    }, {
        key: "teamValidNewTeam",
        value: function teamValidNewTeam(data) {
            return this.axios.$post("/team/team/valid-new-team", data);
        }
    }, {
        key: "validEditTeam",
        value: function validEditTeam(data) {
            return this.axios.$post("/team/team/valid-edit-team", data);
        }
    }]);

    return TeamApi;
}();


//////////////////
// WEBPACK FOOTER
// ./src/api/team.js
// module id = ./src/api/team.js
// module chunks = 34